import{bin2hex}from'@shopgate/pwa-common/helpers/data';import{CATEGORY_PATH}from"../constants";/**
 * Generate category route for navigation.
 * @param {string} id category Id
 * @returns {string}
 */export var getCategoryRoute=function getCategoryRoute(id){return"".concat(CATEGORY_PATH,"/").concat(bin2hex(id));};